import { createSelector, createFeatureSelector } from '@ngrx/store';
import { AppState } from '../../../app.state';

export const selectFeatureShell = createFeatureSelector<any, any>('shell');

export const selectActiveShellLanguages = createSelector(
    selectFeatureShell,
  (state: any) => state.configuration.languages
);

export const selectedLanguage = createSelector(
  selectFeatureShell,
  (state: any) => state.configuration.selectedLanguage
);

export const selectedCurrency = createSelector(
  selectFeatureShell,
  (state: any) => state.configuration.selectedCurrency
);

export const selectCurrencies = createSelector(
  selectFeatureShell,
  (state: any) => state.configuration.currencies
);

export const selectStoreColors = createSelector(
  selectFeatureShell,
  (state: any) => state.configuration.storeColors
);

export const selectedUnitLength = createSelector(
  selectFeatureShell,
  (state: any) => state.configuration.selectedLengthUnit
);

export const selectedUnitWeight = createSelector(
  selectFeatureShell,
  (state: any) => state.configuration.selectedWeighthUnit
);

export const selectedUnitVolume = createSelector(
  selectFeatureShell,
  (state: any) => state.configuration.selectedVolumeUnit
);

export const selectDefaultUser = createSelector(
  selectFeatureShell,
(state: any) => state.userState
);

export const selectCountryIcon = createSelector(
  selectFeatureShell,
(state: any) => state.countryIcon
);

export const selectClient = createSelector(
  selectFeatureShell,
(state: any) => state.clientSelect
);

export const selectAccounts = createSelector(
  selectFeatureShell,
(state: any) => state.accounts
);

export const selectAccountSelect = createSelector(
  selectFeatureShell,
(state: any) => state.accountSelect
);

export const selectRecipientSelect = createSelector(
  selectFeatureShell,
(state: any) => state.recipientSelect
);

export const selectRecipients = createSelector(
  selectFeatureShell,
(state: any) => state.recipients
);

export const selectMenu = createSelector(
  selectFeatureShell,
(state: any) => state.menu
);

export const selectProgreesBar = createSelector(
  selectFeatureShell,
(state: any) => state.progressBar
);

export const selectLoadInitial = createSelector(
  selectFeatureShell,
(state: any) => state.loadInitial
);

export const selectedStoreMenu = createSelector(
  selectFeatureShell,
  (state: any) => state.configuration.storeMenu
);

export const selectOpenAccount = createSelector(
  selectFeatureShell,
  (state: any) => state.configuration.openSelectAccount
);

export const selectSideMenuToggle = createSelector(
  selectFeatureShell,
  (state: any) => state.openSideMenu
);

export const checkSessionExpired = createSelector(
  selectFeatureShell,
  (state: any) => state.sessionExpired
);